document.addEventListener(
    'DOMContentLoaded',
    () => {
        const panel = document.querySelector(
            '[data-meetup-members-panel]'
        );

        if (!panel) {
            return;
        }

        const toggle = document.querySelector(
            '[data-meetup-members-toggle]'
        );

        const close = panel.querySelector(
            '[data-meetup-members-close]'
        );

        const backdrop = panel.querySelector(
            '[data-meetup-members-backdrop]'
        );

        const drawer = panel.querySelector(
            '[data-meetup-members-drawer]'
        );

        const filter = panel.querySelector(
            '[data-meetup-members-filter]'
        );

        const members = panel.querySelectorAll(
            '[data-meetup-member]'
        );

        if (
            !toggle
            || !close
            || !backdrop
            || !drawer
            || !filter
        ) {
            return;
        }

        let closeTimeout = null;

        const resetFilter = () => {
            filter.value = '';

            members.forEach((member) => {
                member.classList.remove(
                    'hidden'
                );
            });
        };

        const openDrawer = () => {
            if (closeTimeout) {
                window.clearTimeout(
                    closeTimeout
                );

                closeTimeout = null;
            }

            panel.classList.remove(
                'hidden'
            );

            panel.setAttribute(
                'aria-hidden',
                'false'
            );

            document.body.classList.add(
                'overflow-hidden'
            );

            window.requestAnimationFrame(
                () => {
                    window.requestAnimationFrame(
                        () => {
                            backdrop.classList.remove(
                                'opacity-0'
                            );

                            drawer.classList.remove(
                                'translate-x-full'
                            );

                            filter.focus();
                        }
                    );
                }
            );
        };

        const closeDrawer = () => {
            backdrop.classList.add(
                'opacity-0'
            );

            drawer.classList.add(
                'translate-x-full'
            );

            panel.setAttribute(
                'aria-hidden',
                'true'
            );

            document.body.classList.remove(
                'overflow-hidden'
            );

            resetFilter();

            closeTimeout =
                window.setTimeout(
                    () => {
                        panel.classList.add(
                            'hidden'
                        );

                        toggle.focus();

                        closeTimeout = null;
                    },
                    300
                );
        };

        toggle.addEventListener(
            'click',
            openDrawer
        );

        close.addEventListener(
            'click',
            closeDrawer
        );

        backdrop.addEventListener(
            'click',
            closeDrawer
        );

        filter.addEventListener(
            'input',
            () => {
                const value =
                    filter.value
                        .trim()
                        .toLowerCase();

                members.forEach(
                    (member) => {
                        const name =
                            member.dataset
                                .memberName
                            ?? '';

                        member.classList.toggle(
                            'hidden',
                            !name.includes(
                                value
                            )
                        );
                    }
                );
            }
        );

        document.addEventListener(
            'keydown',
            (event) => {
                if (
                    event.key === 'Escape'
                    && panel.getAttribute(
                        'aria-hidden'
                    ) === 'false'
                ) {
                    closeDrawer();
                }
            }
        );
    }
);